// Copy for failures returned by the bulk user actions (invite, resend, revoke,
// deactivate, reactivate, role change). Two kinds of key appear here because the
// backend emits two kinds of message on the same response:
//
//   - `err_*` codes, from explicit `errors.add(:org_role_id, "err_...")`
//   - raw Rails validation sentences, from `errors.add(:status, "must be ...")`
//
// Both reach the toast verbatim otherwise, so the sentences are keyed by their
// exact server text. An unmapped sentence still passes through unchanged; only
// unmapped machine codes fall back to the generic message.
const users = {
  err_cannot_change_self: {
    message: 'You cannot change your own role',
  },
  err_cannot_change_super_admin: {
    message: 'Only a Super Admin can change another Super Admin',
  },
  err_not_found: {
    message: 'That user no longer exists. Refresh the page and try again.',
  },
  'must be imported': {
    message: 'This user has already been invited',
  },
  'must be pending': {
    message: 'This user has no pending invitation to resend',
  },
  'must be deactivated': {
    message: 'This user is not deactivated',
  },
  'must be active/pending': {
    message: 'This user is not active',
  },
  'must be pending prior to deactivation': {
    message:
      'This user never accepted an invitation, so they cannot be re-invited. Activate them instead.',
  },
  'must be active prior to deactivation': {
    message:
      'This user never accepted their invitation, so they cannot be activated. Re-invite them instead.',
  },
};

export default users;
